'use client';

import { c as _c } from "react/compiler-runtime";
import { useQuery } from '@tanstack/react-query';
import { UnauthQueryOptions } from '@/api';
const TREND_SIZE = 20;
const trendQueryOptions = UnauthQueryOptions['get:/wello/v2/allows/trend'];
export type TrendKeywordItem = NonNullable<NonNullable<Awaited<ReturnType<NonNullable<ReturnType<typeof trendQueryOptions>['queryFn']>>>['context']>['contents']>[number];
export const useTrendKeywords = () => {
  const $ = _c(6);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      ...trendQueryOptions({
        query: {
          size: TREND_SIZE
        }
      }),
      select: _temp
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    data: t1,
    isPending
  } = useQuery(t0);
  let t2;
  if ($[1] !== t1) {
    t2 = t1 === undefined ? [] : t1;
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const keywords = t2;
  let t3;
  if ($[3] !== isPending || $[4] !== keywords) {
    t3 = {
      keywords,
      isPending
    };
    $[3] = isPending;
    $[4] = keywords;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
};
function _temp(data) {
  return data.context?.contents ?? [];
}